import { render, staticRenderFns } from "./approval-details.vue?vue&type=template&id=69337036"
import script from "./approval-details.vue?vue&type=script&lang=js"
export * from "./approval-details.vue?vue&type=script&lang=js"
import style0 from "./approval-details.vue?vue&type=style&index=0&id=69337036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports